/**
 * @file: ErpProviderLogo.tsx
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { getErpProviderLogoSource } from '@euler/app/flows/erp/utils/erpProviderLogo';
import { FontFamily } from '@euler/components/typography';
import { ErpProviderInfo } from '@euler/model/erp-integrations';
import { memo } from 'react';
import { Image, Text, View } from 'react-native';

/**
 * A provider's mark. Falls back to a lettermark when neither the catalog nor
 * the bundle has an image — a provider added server-side should still render
 * on an app that predates its logo.
 */
export const ErpProviderLogo = memo(
  ({
    provider,
    size,
    name,
  }: {
    provider?: ErpProviderInfo;
    size: number;
    name?: string;
  }) => {
    const source = getErpProviderLogoSource(provider);
    const label = (name ?? provider?.name ?? '?').substring(0, 1);
    return (
      <View
        style={{
          width: size,
          height: size,
          borderRadius: size / 2,
          backgroundColor: '#f0f4f8',
          alignItems: 'center',
          justifyContent: 'center',
          overflow: 'hidden',
        }}
      >
        {source ? (
          <Image
            source={source}
            style={{ width: size * 0.68, height: size * 0.68 }}
            resizeMode="contain"
          />
        ) : (
          <Text
            style={{
              fontSize: size * 0.4,
              color: '#5ba0e0',
              fontFamily: FontFamily.NotoSans.Bold,
            }}
          >
            {label}
          </Text>
        )}
      </View>
    );
  },
);
